import { DTCCampaign } from '../../Apps/Shared/NewCampaigns/DTCCampaigns/types';

export interface DTCCampaignState {
    dtcCampaign: DTCCampaign;
    isLoading: boolean;
    error: string;
}

export const SET_DTC_CAMPAIGN = 'SET_DTC_CAMPAIGN';

export const SET_LOADING = 'SET_LOADING';

export const SET_ERROR = 'SET_ERROR';

interface SetDTCCampaignAction {
    type: typeof SET_DTC_CAMPAIGN;
    payload: DTCCampaign;
}

interface SetLoadingAction {
    type: typeof SET_LOADING;
    payload: boolean;
}

interface SetErrorAction {
    type: typeof SET_ERROR;
    payload: string;
}

export type DTCCampaignActionTypes = SetDTCCampaignAction | SetLoadingAction | SetErrorAction;
